import { Autocomplete, TextField } from "@mui/material";
import { FilterValueType } from "./useFilterState";

interface Option {
  label: string;
  value: FilterValueType;
}

interface FilterAutocompleteProps<T> {
  options: Option[];
  value: FilterValueType | undefined;
  filterKey: keyof T;
  width: string;
  placeholder: string;
  disabled?: boolean;
  updateFilters: (key: keyof T, value: FilterValueType | undefined) => void;
}

const styles = {
  autocomplete: {
    "& .MuiAutocomplete-input": {
      right: "3px !important",
    },
  },
  textField: {
    "& .MuiAutocomplete-input": {
      paddingRight: "12px !important",
    },
  },
} as const;

export const FilterAutocomplete = <T extends { [key: string]: FilterValueType }>({
  options,
  value,
  filterKey,
  width,
  placeholder,
  disabled = false,
  updateFilters,
}: FilterAutocompleteProps<T>) => {
  return (
    <Autocomplete
      disablePortal
      disabled={disabled}
      options={options}
      value={options.find((opt) => opt.value == value) || null}
      onChange={(_, option: Option | null) => {
        updateFilters(filterKey, option?.value);
      }}
      sx={{
        width,
        ...styles.autocomplete,
      }}
      renderInput={(params) => <TextField sx={styles.textField} {...params} placeholder={placeholder} />}
    />
  );
};
